import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';
import {
  SUBCOMMITTEE_APPROVE,
  SUBCOMMITTEE_DETAIL,
  SUBCOMMITTEE_DETAIL_LOG,
  USER_LIST_SUBCOMMITTEE,
  SUBCOMMITTEE_EVENT_LIST,
  CHECK_SUBCOMMITTEE_PARTICIPATION
} from 'manager/http-constants';
import { MESSAGE_CODE } from 'src/app/shared/constant/message-constant';
import { TOAST } from 'src/app/shared/constant/primeng-constants';
import { LoadingState } from 'src/app/shared/html-parts/loading/loading-state';
import {
  MessageData,
  ToastMessageData,
} from 'src/app/shared/html-parts/message-common/message-data';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { ApprovalDialogComponent } from '../common/approval-dialog/approval-dialog.component';
import { DiffTableComponent } from '../common/diff-table/diff-table.component';
import { PlatformComponent } from '../platform.component';
import { SubcommitteeDialogComponent } from '../common/subcommittee-dialog/subcommittee-dialog.component';
import { SUBCOMMITTEE_MEMBER_CONSTANT } from './constant';
import { DatePipe } from '@angular/common';
import { CONSTANT, DATE_FORMAT } from 'src/app/shared/constant/constant';
import { ExportFileService } from 'src/app/shared/html-parts/export-file/export-file.service';
import { LoginService } from 'src/app/shared/service/login.service';
import { SESSION_KEY } from 'src/app/shared/constant/session-constants';

@Component({
  selector: 'app-e202',
  templateUrl: './e202.component.html',
  styleUrls: ['./e202.component.scss', '../platform.component.scss'],
})

/**
 * 分科会詳細
 */
export class E202Component extends PlatformComponent {
  /** 共通部品_承認時ダイアログ */
  @ViewChild(ApprovalDialogComponent)
  approvalDialogComponent: ApprovalDialogComponent;

  /** 共通部品_差分比較 */
  @ViewChild(DiffTableComponent)
  diffTableComponent: DiffTableComponent;

  /** 共通部品_分科会用ダイアログ */
  @ViewChild(SubcommitteeDialogComponent)
  subcommitteeDialogComponent: SubcommitteeDialogComponent

  // 分科会IDを格納
  subcommitteeId: string = this.route.snapshot.params.subcommittee_id;

  // 分科会詳細格納先
  detailSubcommittee: any;

  // 分科会参加メンバー格納先
  subcommitteeMemberList: object[] = new Array();

  // 分科会のイベント・お知らせ格納先
  memberEventDataList: object[] = new Array();

  // 分科会参加状態チェック
  isAlreadyJoin: any;

  // 分科会参加ユーザ数
  userCount: number = 0;

  // 主催/窓口フラグ
  isOrganizerContactFlag: boolean = false;

  // ダウンロード用分科会参加メンバーヘッダ
  subCommittieeHeader: object[] = [
  {field: 'user', header: '氏名'},{field: 'organization_name', header: '団体名称'},{field:'want', header: '本プラットフォームにおける活動で実現したいこと'},{field:'member_kbn', header: 'メンバー区分'},{field:'email', header: 'メールアドレス'}
];

  // ダウンロードデータ作成用
  subcommitteeMemberDownload: object[] = new Array();

  // ダウンロード用分科会参加メンバー用リスト
  subcommitteeMemberDownloadList: object[] = new Array();

  // 分科会参加メンバー：団体名格納先
  organizationNameList: object[] = new Array();

  // 分科会参加団体数
  memberCount: number = 0;

  // 当年度判定フラグ
  currentYearFlag: boolean = false;

  // 分科会参加ボタン表示状態(true:表示 / false:非表示)
  appliCheck: boolean = true;

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    private messageData: MessageData,
    private location: Location,
    private formBuilder: FormBuilder,
    public datePipe: DatePipe,
    private exportFileService: ExportFileService,
    private loginService: LoginService
  ) {
    super(route, commonService, dbOperationService, loadingState);
  }

  async ngOnInit(): Promise<void> {
    await this.getUserLogin();
    // 分科会詳細を取得
    this.getDetailSubcommittee();

    // 分科会参加ボタン表示チェック
    this.checkAppliDate();
  }

  /**
   * 分科会詳細を取得
   */
  public getDetailSubcommittee(): void {

    // 再検索時のメンバー一覧表示フラグをリセット
    this.isOrganizerContactFlag = false;
    this.subcommitteeMemberDownloadList.length = 0;

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(SUBCOMMITTEE_EVENT_LIST);

    // 分科会イベント/お知らせを取得
    this.dbOperationService
      .getNoTemplateData(SUBCOMMITTEE_EVENT_LIST, {"subcommittee_id": this.subcommitteeId}, false)
      .subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, SUBCOMMITTEE_EVENT_LIST);

        if (this.commonService.checkNoneResponse(response)) {
          this.memberEventDataList = new Array();
        } else {
          // 分科会参加ユーザ一覧を格納
          this.memberEventDataList = response.body;
        }
      });

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(SUBCOMMITTEE_DETAIL);

    // 分科会詳細を取得
    this.dbOperationService
      .getNoTemplateDisplayData(SUBCOMMITTEE_DETAIL, this.subcommitteeId, true)
      .subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, SUBCOMMITTEE_DETAIL);

        if (this.commonService.checkNoneResponse(response)) {
          // 警告メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.WARN,
              summary: this.commonService.msg(MESSAGE_CODE.E00003),
              detail: this.commonService.msg(MESSAGE_CODE.E00026),
            })
          );

          // 前画面へ戻る
          this.location.back();
        } else {
          // 分科会詳細を格納
          this.detailSubcommittee = response.body;
          if(!this.decisionPerspective(this.detailSubcommittee.member_id) &&
            !this.decisionSecretariat() && this.detailSubcommittee.status.id != '2'
          ){
            // 異常メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.ERROR,
                summary: this.commonService.msg(MESSAGE_CODE.E00003),
                detail: this.commonService.msg(MESSAGE_CODE.E80002),
                position: TOAST.BOTTOM_RIGHT,
                life: 60000,
              })
            );
            this.loginService.logout(MESSAGE_CODE.N90001);
            return;
          }
          // 過年度判定
          // 当年度取得
          let currentDate = new Date();
          currentDate.setMonth(currentDate.getMonth() - 3);
          let checkDate = new Date(this.detailSubcommittee.create_datetime)
          // 当年度初日(xxxx年4月1日0:00:00)
          let minDate = new Date(currentDate.getFullYear(), 3, 1)
          // 当年度最終日(xxxx年3月31日23:59:59)
          let maxDate = new Date(currentDate.getFullYear() + 1, 2, 31, 23, 59,59, 59)
          // 承認日付が当年度内または、未承認（承認日付がnullかつ承認ステータスが1の場合)
          if( checkDate <= maxDate && minDate <= checkDate || (this.checkNull(this.detailSubcommittee.status_datetime) && "1" == this.detailSubcommittee.status.id) ){
            this.currentYearFlag = true;
          }
        }
      });

    // ログイン状態の場合実施
    if(this.decisionLoginState() ){
      // 画面ロードフラグをON(ロード中状態)
      this.loadingState.loadStart(USER_LIST_SUBCOMMITTEE);

      // 分科会参加ユーザ一覧を取得
      this.dbOperationService
        .getNoTemplateData(USER_LIST_SUBCOMMITTEE, {"subcommittee_id": this.subcommitteeId}, false)
        .subscribe((response) => {
          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.3, USER_LIST_SUBCOMMITTEE);

          if (this.commonService.checkNoneResponse(response)) {
            this.subcommitteeMemberList = new Array();
          } else {
            // 分科会参加ユーザ一覧を格納
            this.subcommitteeMemberList = response.body;
            this.userCount = this.subcommitteeMemberList.length;

            // 「主催・窓口」判定
            this.subcommitteeMemberList.forEach((subcommitteeMember) => {
            if(this.loginUser.user_id == subcommitteeMember['user_id']['id'] && "1" == subcommitteeMember['member_kbn']['id']){
              this.isOrganizerContactFlag = true;
            }
            });
            // ダウンロード用データ作成
            this.subcommitteeMemberList.forEach((subcommitteeMember) => {
              this.subcommitteeMemberDownload = new Array();
              this.subcommitteeMemberDownload["user"] = subcommitteeMember['user_id']['name'];
              this.subcommitteeMemberDownload["organization_name"] = subcommitteeMember['organization_name'];
              this.subcommitteeMemberDownload["want"] = subcommitteeMember['want'];
              this.subcommitteeMemberDownload["member_kbn"] = subcommitteeMember['member_kbn']['name'];
              this.subcommitteeMemberDownload["email"] = subcommitteeMember['email'];
              // 団体名のみを取得しリストに入れる
              this.organizationNameList.push(subcommitteeMember['organization_name']);
              // ダウンロード用のリストに追加する
              this.subcommitteeMemberDownloadList.push(this.subcommitteeMemberDownload);
            });
            // 重複なしの団体名カウントを格納する
            this.memberCount = [...new Set(this.organizationNameList)].length

          }
        });

      // 画面ロードフラグをON(ロード中状態)
      this.loadingState.loadStart(CHECK_SUBCOMMITTEE_PARTICIPATION);

      // 分科会参加状態チェックを取得
      this.dbOperationService
        .getNoTemplateData(CHECK_SUBCOMMITTEE_PARTICIPATION, {"subcommittee_id": this.subcommitteeId, "user_id": this.loginUser.user_id}, false)
        .subscribe((response) => {
          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.3, CHECK_SUBCOMMITTEE_PARTICIPATION);

            if (this.commonService.checkNoneResponse(response)) {
              this.isAlreadyJoin = {isalreadyjoin: 'False'};
            } else {
              // 分科会参加状態チェックを格納
              this.isAlreadyJoin = response.body;
            }
        });
    }
  }

  /**
   * 分科会申請登録/編集(E204)へ遷移する
   */
  public moveE204(): void {
    // 分科会申請登録(E204)へ遷移
    this.router.navigate(['pages/platform/e204/edit'], {
      queryParams: {
        screenId: 'e204',
        subcommittee_id: this.subcommitteeId,
      },
    });
  }

  /**
   * 分科会参加登録(E401)へ遷移する
   */
   public moveE401(): void {
    // 分科会申請登録(E401)へ遷移
    this.router.navigate(['pages/platform/e401'], {
      queryParams: {
        subcommittee_id: this.subcommitteeId,
      },
    });
  }

  /**
   * 内閣府承認ダイアログ表示
   */
  public openSmallApprovalDialog(): void {
    // 内閣府承認ダイアログ表示
    this.approvalDialogComponent.openSmallApprovalDialog(
      SUBCOMMITTEE_APPROVE,
      this.subcommitteeId,
      2006,
      0,
    );
  }

  /**
   * 差分ダイアログ表示
   */
   public openDiffDialog(screen_id: string): void {
     // 差分比較ダイアログ表示
     this.diffTableComponent.openDiffTable(
       screen_id,
       SUBCOMMITTEE_DETAIL,
       SUBCOMMITTEE_DETAIL_LOG,
       this.subcommitteeId,
       2006,
       0,
     );
   }

  /**
  * 区分変更ダイアログ表示
  */
  public openCategoryChangeDialog(member_kbn_id: string, user_id: string): void {
    // 差分比較ダイアログ表示
    this.subcommitteeDialogComponent.openCategoryChange(
      this.subcommitteeId,
      member_kbn_id,
      user_id,
    );
  }

  /**
  * 退会ダイアログ表示
  */
  public openWithdrawalDialog(): void {
    // 差分比較ダイアログ表示
    this.subcommitteeDialogComponent.openWithdrawal(
      this.subcommitteeId
    );
  }

  /**
   * CSV出力
   */
  protected exportCSV() {
    // csvファイル名の設定
    const fileName =
      SUBCOMMITTEE_MEMBER_CONSTANT.CSV_FILENAME +
      CONSTANT.UNDERBAR +
      this.datePipe.transform(new Date(), DATE_FORMAT.DATETIME_HYPHEN);

    // CSVファイル出力
    this.exportFileService.exportCsv(
      fileName,
      this.subCommittieeHeader,
      this.subcommitteeMemberDownloadList,
      false
    );
  }

  /**
   * イベント・お知らせ詳細(E102)へ遷移する
   * @param memberEventId イベント・お知らせID
   */
  public moveE102(memberEventId: string): void {
    // イベント・お知らせ詳細(E102)へ遷移
    this.router.navigate(['pages/platform/e102/' + memberEventId]);
  }

  /**
   * 値NULL判定
   * true: 値がnull, false: 値がnullでない
   */
  public checkNull(val: any): any {
    if(val == null || typeof val === 'undefined' || (val).length == 0){
      return true;
    }else{
      return false;
    }
  }

  /**
   * 分科会参加ボタン表示判定
   */
  public checkAppliDate(): boolean {
    // 本日日付
    let currentDate = new Date();
    // 表示期間(2023年3月31日以降)　//リリース日程の都合による修正
    let checkDate = new Date(2023, 2, 31);// monthは-1する

    // 表示期間外は非表示とする
    if (currentDate > checkDate) {
      this.appliCheck = true;
    } else {
      this.appliCheck = false;
    }
    return this.appliCheck;
  }

  async getUserLogin(){
    return new Promise(resolve => {
      this.loginService.getAuth0LoginState().subscribe((response) => {
        // ログイン状態をセット

        // ログイン状態を判定
        if (response) {
          // ログイン状態の場合

          /* ログインユーザー情報 */
          // セッションからログインユーザ情報取得
          const loginUser = JSON.parse(
            window.sessionStorage.getItem(SESSION_KEY.loginUserInformation)
          );

          // セッションにログインユーザ情報が存在するか否か
          if (loginUser) {
            // セッションにログインユーザが存在する場合

            // 課題・ソリューション結果を取得
            return resolve(null);
          } else {
            // セッションにログインユーザが存在しない場合(初回表示時)

            // ログインユーザ情報取得処理
            this.loginService.getLoginUser().subscribe((response) => {
              // 正常なユーザの為、セッションにユーザ情報を格納
              window.sessionStorage.setItem(
                SESSION_KEY.loginUserInformation,
                JSON.stringify(response.body[0])
              );

              this.loginUser = JSON.parse(window.sessionStorage.getItem(SESSION_KEY.loginUserInformation));
              // 課題・ソリューション結果を取得
              return resolve(null);
            });
          }
        } else {
          // 未ログイン状態の場合

          return resolve(null);
        }
      });
    });
  }
}
